import i18next from 'i18next'
import { z } from 'zod'

import { RefreshRedirectSchema } from './schema'

export const validateRefreshRedirectSchema = (
  { sendRefreshRequestToExternalAdUnitEnabled, targetAdUnitPath }: RefreshRedirectSchema,
  ctx: z.RefinementCtx,
): void => {
  if (targetAdUnitPath === undefined || sendRefreshRequestToExternalAdUnitEnabled === false) {
    return
  }

  const i18nPrefix: string = 'features/adUnit:form.refresher.refreshRedirect.validation.'
  const path: PropertyKey[] = ['refreshRedirect', 'targetAdUnitPath']

  if (targetAdUnitPath.length === 0) {
    ctx.addIssue({
      code: 'custom',
      message: i18next.t(i18nPrefix + 'required'),
      path,
    })
  }

  const adUnitPathRegex: RegExp = /^\/\d+(?:,\d+)?(?:\/[^/]+)+$/

  if (!adUnitPathRegex.test(targetAdUnitPath)) {
    ctx.addIssue({
      code: 'custom',
      message: i18next.t(i18nPrefix + 'invalidFormat'),
      path,
    })
  }
}
